// extracted by css-extract-rspack-plugin
export default {"avatar":"_avatar_GACwX","image":"_image_f4xLj","squared":"_squared_E1k7X","xs":"_xs_mxKce","sm":"_sm_q2aIq","md":"_md_yn212","lg":"_lg_ADJzW"};